'use es6';

import { fromJS } from 'immutable';
import memoize from 'transmute/memoize';
import formatName from 'I18n/utils/formatName';
const compareText = (a, b) => {
  return a.text.localeCompare(b.text);
};
const formatCreateAndOwnHubUserLabel = createAndOwnHubUser => {
  const firstName = createAndOwnHubUser.firstName;
  const lastName = createAndOwnHubUser.lastName;
  const email = createAndOwnHubUser.email;
  const fullName = formatName({
    firstName,
    lastName
  });
  return email ? `${fullName} (${email})`.trim() : fullName;
};
export const getLabelsFromHubUsers = hubUsers => {
  const labelsByUserId = hubUsers.map(hubUser => ({
    text: formatCreateAndOwnHubUserLabel(hubUser),
    value: String(hubUser.id)
  })).sort(compareText);
  return labelsByUserId;
};
export const formatOwnersResponse = memoize(createAndOwnHubUsers => {
  const createAndOwnHubUserMap = {};
  createAndOwnHubUsers.forEach(hubUser => {
    const hubUserId = String(hubUser.id);
    createAndOwnHubUserMap[hubUserId] = hubUser;
  });
  return {
    owners: fromJS(createAndOwnHubUserMap),
    ownerLabels: getLabelsFromHubUsers(Object.values(createAndOwnHubUserMap))
  };
});